import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { type CustomMutationParams, useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { chUpdateMedicationMutation } from "@/modules/patients/detail/medication/ch/services/__generated__/chUpdateMedicationMutation.graphql"

const mutation = graphql`
  mutation chUpdateMedicationMutation($input: Ch_updateMedicationInput!, $connections: [ID!]!) {
    ch_updateMedication(input: $input) {
      ch_Medication @appendNode(connections: $connections, edgeTypeName: "Ch_medicationsEdge") {
        id
        ...chMedicationFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

const useChUpdateMedicationMutation = (params?: CustomMutationParams) => {
  const [commit, isFlight] = useMutationWithErrorDialog<chUpdateMedicationMutation>(mutation, params)

  const commitHandler = useCallback(
    (config: UseMutationConfig<chUpdateMedicationMutation>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useChUpdateMedicationMutation }
